import React from 'react';
import { ModalWrapper, Reoverlay } from 'reoverlay';

interface ConsentDialogProps {
  onConsent: (consent: boolean) => void;
}

export default function ConsentDialog({ onConsent }: ConsentDialogProps): JSX.Element {
  return (
      <ModalWrapper
      onClose={() => {}}   // prevent closing by clicking outside
      animation = {'fade'}
      >
      <div
          style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '8px',
              maxWidth: '780px',
              margin: 'auto',
              textAlign: 'center',
          }}
      >                
          <h4>Tracking-Einwilligung</h4>
          <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
          Diese Seite verwendet die Tracking-Technologie <b>„Meta Pixel“</b> der Meta Platforms Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
          </div>
          <details>
            <summary style={{ color: "blue", textDecorationLine: 'underline' }}>Details</summary>
            <div style={{fontSize: 12, textAlign: 'left', fontFamily: 'Arial' }}>
            <b>Welche Daten werden verarbeitet?</b>
            <br></br>
            <br></br>
            <ul>
              <li>Besuchte Seiten und Interaktionen (Page Views, Klicks)</li>
              <li>IP-Adresse, Browserinformationen</li>
              <li>Referrer-URL</li>
              <li>Zeitstempel</li>
            </ul>
            <b>Zweck der Verarbeitung:</b>
            <br></br>
            <br></br>
            <ul>
              <li>Conversion-Tracking (Erkennung, ob Nutzer nach Klick auf eine Facebook-Werbeanzeige eine gewünschte Aktion ausführen)</li>
              <li>Remarketing / Retargeting (gezielte Werbung auf Facebook)</li>
              <li>Optimierung unserer Werbeanzeigen auf Grundlage von Nutzerdaten</li>
            </ul>
            <b>Rechtsgrundlage:</b>
            <br></br>
            Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO und § 25 TTDSG.
            <br></br>
            <br></br>
            <b>Datenübermittlung in Drittländer:</b>
            <br></br>
            Die erhobenen Daten können an Meta in den USA übermittelt werden. Dort besteht kein gleichwertiges Datenschutzniveau. Meta verwendet Standardvertragsklauseln, um ein angemessenes Schutzniveau sicherzustellen. 
            <br></br>
            <br></br>
            <b>Speicherdauer:</b>
            <br></br>
            Die Daten werden bis zu 180 Tage gespeichert. Meta kann bestimmte Daten länger speichern, entsprechend den eigenen Richtlinien. 
            <br></br>
            <br></br>
            <b>Widerruf der Einwilligung:</b>
            <br></br>
            Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, z. B. über die Cookie-Einstellungen oder durch Löschen der Cookies in Ihrem Browser. Der Widerruf ist ebenso einfach wie die Erteilung der Einwilligung. 
            </div>
          </details>
          <div style={{fontSize: 14, fontFamily: 'Arial' }}>
          <br></br>
          <br></br>
          Weitere Informationen finden Sie in unserer Datenschutzerklärung sowie in den <a href="https://de-de.facebook.com/privacy/policy/" target="_blank" rel="noreferrer">Meta-Datenschutzrichtlinien</a>.
          <br></br>
          <br></br>
          <br></br>
          </div>
          <div style={{fontFamily: 'Arial' }}>
          <b>Sind Sie mit der Verwendung des „Meta Pixel“ einverstanden?</b>
          <br></br>
          <br></br>
          </div>
          <button onClick={() => onConsent(true)} style={{ marginRight: '1rem', borderRadius: '8px', width: '80px', border: 0, backgroundColor: "light-gray" }}>
          Ja
          </button>
          <button onClick={() => onConsent(false)} style={{ borderRadius: '8px', width: '80px', border: 0, backgroundColor: "light-gray" }}>
          Nein
          </button>
      </div>
    </ModalWrapper>
  );
}
